// Склонение русского существительного по числу через CLDR-правила платформы
// (Intl.PluralRules). Формы задаёт вызывающий: { one:'год', few:'года', many:'лет' }.
// Для ru целые числа дают one/few/many. Категория 'other' встречается только у дробных
// чисел, поэтому мы отправляем её в many.
const RU_PLURAL_RULES = new Intl.PluralRules('ru')

export interface RuPluralForms {
  one: string
  few: string
  many: string
}

export function pluralizeRu(count: number, forms: RuPluralForms): string {
  const category = RU_PLURAL_RULES.select(Math.abs(count))
  if (category === 'one') return forms.one
  if (category === 'few') return forms.few
  return forms.many
}
